module.exports = __webpack_public_path__ + "media/VW_Skeeball_091120_enc-cs.13f173d2.mp4";